// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rDp3","title":"Header_title__16mIp","left":"Header_left__1Ih9F","clinicName":"Header_clinicName__1ZIor"};